import { Stack, Text } from "@chakra-ui/react";
import FormGrid from "@raiden/library/components/Form/FormGrid";
import PlacesAutocomplete from "@raiden/library/components/Form/PlacesAutocomplete";
import SchoolLevelSelect from "@raiden/library/components/Form/SchoolLevelsSelect";
import FormController from "@raiden/library/components/ReactHookForm/FormController";
import ObserverRHF from "@raiden/library/components/ReactHookForm/ObserverRHF";
import { HOLDERS_TYPES_VALUE_CHILD } from "@raiden/library/constants/holders";
import { PLACES_TYPES_VALUE_SCHOOL } from "@raiden/library/constants/places";
import { useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";
import ContentBox from "../../../components/ContentBox";

function HoldersFormSchooling() {
  const intl = useIntl();

  const { setValue } = useFormContext();

  return (
    <ObserverRHF
      names={["data.type"]}
      render={({ values: [type] }) =>
        type === HOLDERS_TYPES_VALUE_CHILD ? (
          <ContentBox
            title={intl.formatMessage({
              defaultMessage: "Année scolaire courante",
            })}>
            <Stack spacing="1rem">
              <Text colorScheme="gray">
                {intl.formatMessage({
                  defaultMessage: "Complétez la classe de l'année courante.",
                })}
              </Text>

              <FormGrid>
                <FormController
                  name="data.schoolings.0.school_id"
                  rules={{
                    required: true,
                    onChange: (value) => {
                      setValue("data.schoolings.0.level", "");
                    },
                  }}
                  defaultValue=""
                  label={intl.formatMessage({ defaultMessage: "École" })}
                  renderWithFormControl={(field) => (
                    <PlacesAutocomplete
                      type={[PLACES_TYPES_VALUE_SCHOOL]}
                      {...field}
                    />
                  )}
                />

                <ObserverRHF
                  names={["data.environment_id", "data.schoolings.0.school_id"]}
                  render={({ values: [environmentId, schoolId] }) => (
                    <FormController
                      name="data.schoolings.0.level"
                      rules={{
                        required: true,
                      }}
                      defaultValue=""
                      isDisabled={(schoolId ?? "") === ""}
                      label={intl.formatMessage({ defaultMessage: "Niveau" })}
                      renderWithFormControl={(field) => (
                        <SchoolLevelSelect
                          {...field}
                          schoolId={schoolId}
                          environmentId={environmentId}
                        />
                      )}
                    />
                  )}
                />
              </FormGrid>
            </Stack>
          </ContentBox>
        ) : null
      }
    />
  );
}

export default HoldersFormSchooling;
